import angular from 'angular';
import config from 'app/config';
import template from './error.tpl.html';
import './error.scss';

class ErrorController {
  /** @ngInject */
  constructor($rootScope) {
    this.config = config;
  }
}

ErrorController.$inject = ["$rootScope"];

class ErrorComponent {
  constructor() {
    this.template = template;
    this.controller = ErrorController;
  }
}

export default angular
.module("error.view", [])
.component("error", new ErrorComponent())
.name;



// export default angular
//   .module('error.view', [])
//   .component('error', {
//     template,
//   })
//   .name;
